var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sidebar-close-btn d-block position-absolute bg-gray-50 bg-gray-200-hover border-right text-muted overflow-hidden text-center",attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" ✕ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }